export const ENV = {
  production: true,
  baseUrl: '/api/',
  version: '1.0.0'
}
